<template>
  <div class="header">
    <div style="display: flex;alignItems:center">
      <!-- <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" /> -->
      <h2 class="details-title">{{ title }}</h2>
    </div>

    <div class="header-right" >
      <!-- 门店公客也要有认领 -->
      <a-button
        style="border: none; background-color: #fff"
        class="icon-r"
        @click="openClaimModal"
        v-if="userInfo.dishType !== '1'"
      >
        <div class="icon-i icon-ii" :class="{ unclickBgc: userInfo.dishType === '1' }">
          <i class="iconfont icon-bianji1"></i>
        </div>
        <span class="color31c170" :class="{ unclickColor: userInfo.dishType === '1' }">认领</span>
      </a-button>
      <!-- 全部房源进入 离职人员  具备LZXG权限 不是公客 -->
      <div class="icon" @click="updateTourisDishTypePrivateToCompany" v-if="userInfo.dishType !== '1'&&this.$route.query.activeNum === '1'&&this.$route.query.userStatus==='1'&& lzxgPorims">
        <div class="icon-i">
          <i class="iconfont icon-genjin"></i>
        </div>
        <div class="color6370f6">转公客</div>
      </div>
      <template v-if="userInfo.dishType">
        <div class="icon" @click="isWatchFn" v-if="userInfo.accendantId === uidObj.userId">
          <div class="icon-i">
            <i class="iconfont icon-chakan"></i>
          </div>
          <span class="color6370f6">查看</span>
        </div>
        <div class="icon" @click="isWatchFn" v-else v-hasPermi="['houses:lesseeInfo:query']">
          <div class="icon-i">
            <i class="iconfont icon-chakan"></i>
          </div>
          <span class="color6370f6">查看</span>
        </div>
      </template>
      <template v-if="userInfo.dishType === '1'">
        <div class="icon" @click="editBtn" v-if="userInfo.accendantId === uidObj.userId">
          <div class="icon-i">
            <i class="iconfont icon-bianji1"></i>
          </div>
          <span class="color6370f6">编辑</span>
        </div>

        <div class="icon" @click="toFollow" v-if="userInfo.accendantId === uidObj.userId">
          <div class="icon-i">
            <i class="iconfont icon-genjin"></i>
          </div>
          <span class="color6370f6">写跟进</span>
        </div>

        <a-popover class="bottomRight" placement="bottomRight" v-model="visible" trigger="click">
          <a slot="content" @click="visible = false">
            <div
              class="btn_more"
            >
              更多
            </div>

            <a-divider />
            <div
              class="btn_more"
              @click="setFive"
              v-if="userInfo.accendantId === uidObj.userId"
            >
              {{ userInfo.identityFive === 'N' ? '设为五客' : '取消五客' }}
            </div>
            <a-divider v-if="userInfo.accendantId === uidObj.userId" />

            <div
              class="btn_more"
              @click="setGood"
              v-if="userInfo.accendantId === uidObj.userId"
            >
              {{ userInfo.identityExcellent === 'N' ? '设为优质' : '取消优质' }}
            </div>
            <a-divider v-if="userInfo.accendantId === uidObj.userId" />

            <div
              class="btn_more"
              @click="openMainTainerModal"
              v-hasPermi="['houses:lesseeRequirement:accendant']"
            >
              转维护人
            </div>
            <a-divider v-hasPermi="['houses:lesseeRequirement:accendant']" />
            <div
              class="btn_more"
              @click="transferValid"
              v-if="isValid || AManager"
            >
              {{ userInfo.requirementStatus == '1'? '转无效':'转有效' }}
            </div>
            <a-divider v-if="isValid||AManager" />
            <div
              class="btn_more"
              @click="openSuspendModal"
              v-hasPermi="['houses:lesseeRequirement:edit']"
            >
              {{ userInfo.isSuspended && userInfo.isSuspended === 'Y' ? '取消暂缓' : '设为暂缓' }}
            </div>
            <a-divider v-hasPermi="['houses:lesseeRequirement:edit']" />

            <div
              class="btn_more"
              @click="synchronizationFn"
            >
              一键同步
            </div>
            <a-divider />
          </a>
          <div class="icon">
            <div class="icon-i">
              <i class="iconfont icon-gengduo"></i>
            </div>
            <span class="color6370f6">更多</span>
          </div>
        </a-popover>
      </template>
    </div>
  </div>
</template>

<script>
import { getUser } from '@/api/system/user'
export default {
    props: {
        aManager: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        userInfo: {
          type: Object,
          default: () => ({})
        },
        uidObj: {
          type: Object,
          default: () => ({})
        }
    },
    watch: {
      userInfo: {
        handler (val) {
            console.log(val, val.accendantId, 'userInfo')
        },
        deep: true,
        immediate: true
      },
      uidObj: {
        handler (val) {
          console.log(val, val.userId, 'uidObj')
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      lzxgPorims () {
      const arr = ['LZXG']
        const loginRole = this.loginUser.data.roles
        let status = false
        loginRole.forEach(el => {
          if (arr.includes(el)) {
            status = true
          }
        })
        console.log(status, '是否具备离职相关权限')
        return status
      },
      // 是否能领取
      isCeive () {
        const { activeNum, storeId, teamId } = this.$route.query
        const userDeptId = this.loginUser.data.user.deptId
        // 能够进入这个门店公客详情的 我看得到的门店公客 都是满足当前登录人的ID属于这个门店ID，或者说属于这个部门ID
        // if (activeNum == '4' || activeNum == '1') {
        //   if (userDeptId == storeId || userDeptId == teamId) {
        //     return true
        //   } else {
        //     return false
        //   }
        // }
        return true
      }
    },
    data () {
      const userInfo = this.$getters.userInfo
    console.log(userInfo, 'userInfo数据')
    const isValid = userInfo.data.permissions.includes('houses:lesseeRequirement:transferValid') || userInfo.data.permissions.includes('*:*:*')
      //  console.log(this.AManager,'AManager',isValid)
        return {
          isValid,
          visible: false,
          loginUser: this.$getters.userInfo
        }
  },
  mounted () {
    console.log(this.userInfo, 'userInfo适合')
  },
  methods: {
       // 拥有LZXG权限的管理人员 可以把离职人员的 私客转公客
    updateTourisDishTypePrivateToCompany () {
       this.$emit('updateTourisDishTypePrivateToCompany')
    },
      // 转有效
      transferValid () {
          const type = this.userInfo.requirementStatus
          this.$emit('transferValid', type == '1' ? '2' : '1')
      },
      // 打开认领弹窗
      openClaimModal () {
        this.$emit('openClaimModal', true)
      },
      // 查看
      isWatchFn () {
        this.$emit('isWatchFn')
      },
       // 编辑
      editBtn () {
        this.$emit('editBtn')
      },
       // 写跟进
      toFollow () {
        this.$emit('toFollow')
      },
      // 设为五客
      setFive () {
        this.$emit('setFive')
      },
      // 设为优质
      setGood () {
        this.$emit('setGood')
      },
      // 打开转维护弹窗
      openMainTainerModal () {
        this.$emit('openMainTainerModal')
      },
      // 打开暂缓弹窗
      openSuspendModal () {
        this.$emit('openSuspendModal')
      },
      // 一键同步
      synchronizationFn () {
        this.$emit('synchronizationFn')
      }
    }
}
</script>

<style lang="less" scoped>
  /deep/.ant-divider-horizontal {
    margin: 9px 0;
  }
.btn_more{
  color: black;
  width: 150px;
  text-align: center;
}
.btn_more:hover{
  color:var(--ThemeColor)
}
.details-title {
    margin-bottom: 0px;
    font-weight: 700;
    font-size: 20px;
  }
.header {
    display: flex;
    justify-content: space-between;
    .header-right {
      display: flex;
      .color31c170 {
        color: #31c170;
      }
      .color6370f6 {
        color: var(--ThemeColor);
      }
      .icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 20px;
        cursor: pointer;

        .icon-i {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          background-color: var(--ThemeColor);
          color: white;
          text-align: center;
          line-height: 45px;
          .iconfont {
            font-size: 20px;
          }
        }
      }
      .icon-r {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 20px;
        padding: 0;
        .icon-i {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          background-color: var(--ThemeColor);
          color: white;
          text-align: center;
          line-height: 45px;
          .iconfont {
            font-size: 20px;
          }
        }
        .icon-ii {
          background-color: #31c170;
        }
      }
      .unclickColor {
        color: gray !important;
      }
      .unclickBgc {
        background-color: gray !important;
      }
    }
  }
</style>
